// ProtectedRoute.js
import React from 'react';
import { Navigate, Outlet} from 'react-router-dom';
import { useAuth } from '../signin/authcontext.jsx';

const ProtectedRoute = () => {
  const { user, loading } = useAuth();

  

  return !loading && user ? (
    <Outlet/>
  ) : (
    <Navigate to="/login" replace />
  );
};

export default ProtectedRoute;